import { API, generic } from "api"

export default class NotesService {
  static show = async ({ pageState, chapterId, noteId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_NOTES_SHOW_STATUS",
      stateDataKey: ["note", "all_notes", "chapter"],
      stateErrorKey: ["noteErrors", "all_notesErrors", "chapterErrors"],
      apiEndpoint: API.students.notes.show,
      apiUrlReplacements: { chapterId, noteId },
      apiData: {},
      errorMessage: "Note could not be fetched"
    })
  }
}
